module.exports = __webpack_public_path__ + "img/serviceGeneric.787800e8.png";